import React, { useContext } from 'react';

import styled from '@emotion/styled';

import WhatsNewModalIcon from '../../../Icons/WhatsNewModalIcon';
import { ModalContext } from '../../ModalContext';

interface WhatIsNewModalContainerProps {
  children: React.ReactNode;
  description?: string;
  successComponent?: () => React.ReactNode;
  showSuccessComponent?: boolean;
  handleCloseIconClick?: () => void;
  removeTitleAndControl?: boolean;
}
const WhatIsNewModalContainer: React.FC<WhatIsNewModalContainerProps> = ({
  children,
  description,
  successComponent,
  showSuccessComponent,
  handleCloseIconClick,
  removeTitleAndControl = false,
}) => {
  const modalContext = useContext(ModalContext);

  const onClickCancel = (e: any) => {
    modalContext?.setShowModal(false);
    handleCloseIconClick && handleCloseIconClick();
    // setShowSuccessComponent && setShowSuccessComponent(false);
  };

  return (
    <Container
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      {showSuccessComponent ? (
        successComponent && successComponent()
      ) : (
        <>
          {!removeTitleAndControl && (
            <HeaderSection>
              <HeaderArea>
                <div></div>
                <IconContainer onClick={onClickCancel}>
                  <WhatsNewModalIcon />
                </IconContainer>
              </HeaderArea>

              {description && <Description>{description}</Description>}
            </HeaderSection>
          )}
          {children}
        </>
      )}
    </Container>
  );
};

export default WhatIsNewModalContainer;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 40px 56px;
  border-radius: 16px;
  width: 874px;
  gap: 24px;
  margin-top: 25%;
  margin-bottom: 146px;
  background-color: ${({ theme }) => theme.palette.brandBackdrop};
  background-image: url('/static/svg/whatIsNewBgImg.svg');
  background-repeat: no-repeat;
  background-position: top right;
  height: fit-content;

  @media (max-width: 884px) {
    padding: 32px;
    margin-right: 25px;
    margin-left: 25px;
    width: calc(100vw - 50px);
  }

  @media (max-width: 480px) {
    padding: 24px;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const IconContainer = styled.div`
  cursor: pointer;
`;

const Description = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
